/**
 * Hebrew-name initials avatar — picks 1-2 chars from the name and routes to
 * one of the mockup's color palettes deterministically by hashing the name.
 * Matches the mockup's `.avatar` + color classes (av-blue/av-coral/...).
 */
const PALETTE = ['av-blue', 'av-teal', 'av-coral', 'av-amber', 'av-purple', 'av-green'] as const;

function initials(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return '?';
  const parts = trimmed.split(/\s+/);
  if (parts.length === 1) return parts[0]!.slice(0, 2);
  return (parts[0]![0] ?? '') + (parts[parts.length - 1]![0] ?? '');
}

function colorFor(seed: string): (typeof PALETTE)[number] {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) | 0;
  return PALETTE[Math.abs(h) % PALETTE.length]!;
}

export function Avatar({ name, size = 'md' }: { name: string; size?: 'sm' | 'md' | 'lg' }) {
  const cls = `avatar ${colorFor(name)} avatar-${size}`;
  return <div className={cls}>{initials(name)}</div>;
}
